export default __webpack_public_path__ + "images/0xefd81eec32b9a8222d1842ec3d99c7532c31e348.png";